[
  {
    "id": "SR-B7P-PANNENKOEK-V01",
    "module": "SpellingRegel",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "tussen_n_s",
    "familyId": "SR-TUSSEN-N",
    "conceptId": "compound_linking_n",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welke spelling is goed?",
    "options": ["pannenkoek", "pannekoek", "pannekoock", "pannenkoock"],
    "correctAnswer": 0,
    "explanation": "'Pannenkoek' is correct. Bij samenstellingen met een meervoud in het eerste deel krijg je een tussen-n: pannen (meervoud van pan) + koek = pannenkoek.",
    "distractorExplanations": {
      "1": "'Pannekoek' mist de tussen-n. Het eerste deel is 'pannen' (meervoud), dus de 'n' hoort erbij.",
      "2": "'Pannekoock' mist de tussen-n én heeft een verouderde spelling. In modern Nederlands is het 'koek', niet 'koock'.",
      "3": "'Pannenkoock' heeft de juiste tussen-n, maar 'koock' is een verouderde spelling."
    }
  },
  {
    "id": "SR-B7P-PAARDENSTAART-V01",
    "module": "SpellingRegel",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "tussen_n_s",
    "familyId": "SR-TUSSEN-EN",
    "conceptId": "compound_linking_en",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welke spelling is juist?",
    "options": ["paardenstaart", "paardestaart", "paardensstaart", "paardestaert"],
    "correctAnswer": 0,
    "explanation": "'Paardenstaart' is correct. Bij samenstellingen met dieren krijg je vaak een tussen-en: paarden + staart. Vergelijk: kippenhok, hondenriem.",
    "distractorExplanations": {
      "1": "'Paardestaart' mist de 'n'. Het meervoud is 'paarden', dus de volledige vorm hoort in de samenstelling.",
      "2": "'Paardensstaart' heeft een dubbele 's'. Na 'paarden' volgt gewoon 'staart' met één 's'.",
      "3": "'Paardestaert' is een verouderde spelling. In modern Nederlands schrijf je 'staart', niet 'staert'."
    }
  }
]